import * as React from 'react';
import photoStyle from '../photo/Photo.less';
import DialogWrapper from '../dialog/dialog_wrapper';
import { callbackify } from 'util';

interface PhotoDrawProps extends React.ClassAttributes<any> {
    imageData: string;
    imageURL: string;
    onCloseDraw: () => void;
    height: number;
    width: number;
    realHeight: number;
    realWidth: number;
    name: string;
    onDrawDone: (data: string) => void;

}

export interface PhotoDrawState {
    dummy?: string;
}

export class PhotoDraw extends React.Component<PhotoDrawProps, PhotoDrawState> {

    constructor(props: any) {
        super(props);
        this.draw = this.draw.bind(this);
    }

    private canvasRef: any;
    private canvasRefHidden: any;
    private mouseDown = false;
    private lastX = -1;
    private lastY = -1;
    private points: Array<any> = [];

    componentDidMount() {
        const ctx = this.canvasRef.getContext('2d');
        const ctx2 = this.canvasRefHidden.getContext('2d');
        const img = new Image();
        img.setAttribute('crossOrigin', 'Anonymous');

        ctx.fillStyle = 'white';
        ctx2.fillStyle = 'white';

        ctx.fillRect(0, 0, this.canvasRef.width, this.canvasRef.height);
        ctx2.fillRect(0, 0, this.props.realWidth, this.props.realHeight);

        if (this.props.imageData) {
            img.src = this.props.imageData;
        } else if (this.props.imageURL) {
            img.src = this.props.imageURL;
        }

        img.onload = () => {
            ctx.drawImage(img, 0, 0, this.props.width, this.props.height);
            ctx2.drawImage(img, 0, 0, this.props.realWidth, this.props.realHeight);
        };
    }

    render() {
        return (
            <div
                style={{
                    width: this.props.width,
                    height: this.props.height,
                    margin: 'auto',
                    textAlign: 'center'
                }}
            >
                <canvas
                    style={{ border: '1px solid #AAA', touchAction: 'none', width: '100%', height: '100%' }}
                    ref={(ref) => this.canvasRef = ref}
                    id={'canvas_' + this.props.name}
                    width={this.props.width}
                    height={this.props.height}
                    onMouseDown={() => this.mouseDown = true}
                    onMouseUp={() => this.mouseDown = false}
                    onMouseLeave={() => this.mouseDown = false}
                    onMouseMove={this.draw}
                    onTouchStart={() => this.mouseDown = true}
                    onTouchEnd={() => this.mouseDown = false}
                    onTouchCancel={() => this.mouseDown = false}
                    onTouchMove={this.draw}
                />
                <div>
                    <img
                        className={photoStyle.iconsvg}
                        src='src/icons/icons8-ok.png'
                        onClick={() => this.props.onDrawDone(this.canvasRefHidden.toDataURL())}
                    />
                    <img
                        className={photoStyle.iconsvg}
                        src='src/icons/icons8-cancel.svg'
                        onClick={this.props.onCloseDraw}
                    />
                    <img
                        className={photoStyle.iconsvg}
                        src='src/icons/icons8-rewind.png'
                        onClick={() => this.clear()}
                    />
                    {/* <img
                        className={photoStyle.iconsvg}
                        src='src/icons/icons8-rewind.png'
                        onClick={() => this.rotate()}
                    /> */}
                    <canvas
                        style={{ display: 'none' }}
                        ref={(ref) => this.canvasRefHidden = ref}
                        id={'canvas2_' + this.props.name}
                        width={this.props.realWidth}
                        height={this.props.realHeight}
                    />
                </div>
            </div>
        );
    }

    rotate() {

        const ctx = this.canvasRef.getContext('2d');
        const ctx2 = this.canvasRefHidden.getContext('2d');
        ctx.clearRect(0, 0, this.canvasRef.width, this.canvasRef.height);
        ctx2.clearRect(0, 0, this.props.realWidth, this.props.realHeight);

        ctx.fillStyle = 'white';
        ctx2.fillStyle = 'white';
        ctx.fillRect(0, 0, this.canvasRef.width, this.canvasRef.height);
        ctx2.fillRect(0, 0, this.props.realWidth, this.props.realHeight);

        const img = new Image();
        img.src = this.props.imageData;
        img.onload = () => {
            ctx.drawImage(img, 0, 0, this.canvasRef.width, this.canvasRef.height);
            ctx2.drawImage(img, 0, 0, this.props.realWidth, this.props.realHeight);
        };

        ctx.translate(this.canvasRef.width / 2, this.canvasRef.height / 2);
        ctx2.translate(this.props.realWidth / 2, this.props.realHeight / 2);


        ctx.rotate(90 * Math.PI / 180);
        ctx2.rotate(90 * Math.PI / 180);

        ctx.drawImage(img, 0, 0, -this.canvasRef.width / 2, -this.canvasRef.height / 2);
        ctx2.drawImage(img, 0, 0, -this.props.realWidth / 2, -this.props.realHeight / 2);
        ctx.translate(-this.props.width / 2, -this.props.height / 2);
        ctx2.translate(-this.props.realWidth / 2, -this.props.realHeight / 2);

        ctx.restore();
        ctx2.restore();


    }
    clear() {
        this.points = [];
        const ctx = this.canvasRef.getContext('2d');
        const ctx2 = this.canvasRefHidden.getContext('2d');
        if (this.props.imageData) {
            const img = new Image();
            img.src = this.props.imageData;
            img.onload = () => {
                ctx.drawImage(img, 0, 0, this.props.width, this.props.height);
                ctx2.drawImage(img, 0, 0, this.props.realWidth, this.props.realHeight);
            };
        } else
            if (this.props.imageURL) {
                const img = new Image();
                img.src = this.props.imageURL;
                img.onload = () => {
                    ctx.drawImage(img, 0, 0, this.props.width, this.props.height);
                    ctx2.drawImage(img, 0, 0, this.props.realWidth, this.props.realHeight);
                };
            } else {
                ctx.clearRect(0, 0, this.canvasRef.width, this.canvasRef.height);
                ctx2.clearRect(0, 0, this.props.realWidth, this.props.realHeight);

                ctx.fillStyle = 'white';
                ctx2.fillStyle = 'white';
                ctx.fillRect(0, 0, this.canvasRef.width, this.canvasRef.height);
                ctx2.fillRect(0, 0, this.props.realWidth, this.props.realHeight);
            }
    }
    draw(evt: any) {
        const bbox = this.canvasRef.getBoundingClientRect();
        let x = evt.clientX - bbox.left;
        let y = evt.clientY - bbox.top;
        if (evt.changedTouches) {
            x = evt.changedTouches[0].clientX - bbox.left;
            y = evt.changedTouches[0].clientY - bbox.top;
        }
        if (this.mouseDown) {
            if (this.lastX > -1 && this.lastY > -1) {
                // 1. Canvas
                const ctx = this.canvasRef.getContext('2d');
                ctx.lineWidth = 4;
                ctx.beginPath();
                ctx.moveTo(this.lastX, this.lastY);
                ctx.lineTo(x, y);
                ctx.stroke();
                // 2. Canvas
                const factX = this.props.realHeight / this.props.height;
                const factY = this.props.realWidth / this.props.width;
                const ctx2 = this.canvasRefHidden.getContext('2d');
                ctx2.lineWidth = 4;
                ctx2.beginPath();
                ctx2.moveTo(this.lastX * factX, this.lastY * factY);
                ctx2.lineTo(x * factX, y * factY);
                ctx2.stroke();
            }
            this.lastX = x;
            this.lastY = y;
            // this.canvasRef.getContext('2d').fillRect(x, y, 2, 2, '#000');
        } else {
            this.lastX = -1;
            this.lastY = -1;
        }
    }
}
